import { render, staticRenderFns } from "./SeatLayout.vue?vue&type=template&id=2f0e6246&scoped=true&"
import script from "./SeatLayout.vue?vue&type=script&lang=js&"
export * from "./SeatLayout.vue?vue&type=script&lang=js&"
import style0 from "./SeatLayout.vue?vue&type=style&index=0&id=2f0e6246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0e6246",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
